module.exports = __webpack_public_path__ + "static/img/Daniel-Saifiti.33d42c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Saifiti.jpg
// module id = cDaF
// module chunks = 0